import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "w90 pad15"
}
const _hoisted_10 = { class: "fl w30 pad10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "ロゴ変更", -1)
const _hoisted_12 = { class: "mt30" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "fw600 alertBg"
}
const _hoisted_16 = { class: "fl w65" }
const _hoisted_17 = {
  style: {
                                        paddingBottom: 0,
                                    },
  class: /*#__PURE__*/_normalizeClass(`rad8 kakugo calendarfirst ofs lgreyBg pad20 with_shadow mt20`)
}
const _hoisted_18 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_19 = {
  class: "mc",
  style: {"width":"450px"}
}
const _hoisted_20 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0",
  class: "with_white_bg",
  style: {"margin":"0"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "w100 skyblueBg centered fw600 fs12",
    style: {"height":"5px","padding-top":"0px","letter-spacing":"0.3px"}
  })
], -1)
const _hoisted_22 = { style: {"border-bottom":"1px solid #eee"} }
const _hoisted_23 = {
  class: "w100 text-left",
  style: {"padding":"10px 20px 15px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#8e8e8e","margin-top":"-3px"} }, "クラウド日程調整", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"100%","padding":"10px 20px 15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { class: "clear" })
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "w90 pad15 mt20"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "メールタイトルの先頭に文字を追加"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, "メールのタイトルの頭出しに共通の文字を入れます。")
], -1)
const _hoisted_36 = { class: "fl w65" }
const _hoisted_37 = { class: "fl" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = {
  key: 2,
  class: "w90 pad15 mt20"
}
const _hoisted_41 = { class: "fl w30 pad10" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "メール表示スタイルを変更", -1)
const _hoisted_43 = { class: "mt30" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "fl w65" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = {
  key: 3,
  class: "w90 pad15 mt20"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "署名"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, [
    /*#__PURE__*/_createTextVNode("シンプルの場合に表示する署名を作成します。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_51 = { class: "fl w65" }
const _hoisted_52 = { class: "fl" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = {
  key: 4,
  class: "w90 pad15 mt20"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "チャット送信時、メール通知に入力内容を表示"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, [
    /*#__PURE__*/_createTextVNode(" チャットを送信した際に、調整相手に届くメール文にチャットの内容を表示します。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_56 = { class: "fl w65" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { class: "pad40 w100" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UserSettingsAddressBook = _resolveComponent("UserSettingsAddressBook")!
  const _component_TemplatesContent = _resolveComponent("TemplatesContent")!
  const _component_ImageBoardModal = _resolveComponent("ImageBoardModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `mail` ? `fw600 selected` : ``}`),
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`mail`)))
                }, " 全体設定 ", 2),
                (_ctx.UserPermissionsOption.permitEdit(_ctx.rm.userInfo, `user_settings`, `user_settings_address_book`))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `addressbook` ? `fw600 selected` : ``}`),
                      style: {"width":"120px"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`addressbook`)))
                    }, " アドレス帳 ", 2))
                  : _createCommentVNode("", true),
                (_ctx.UserPermissionsOption.permitEdit(_ctx.rm.userInfo, `user_settings`, `user_settings_address_book`))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `templates` ? `fw600 selected` : ``}`),
                      style: {"width":"120px"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategory(`templates`)))
                    }, " テンプレ ", 2))
                  : _createCommentVNode("", true),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `mail`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (!_ctx.us || _ctx.us.mail_display_type == `rich`)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("p", _hoisted_12, [
                              _createTextVNode(" メール上のヘッダーにあるロゴを変更できます。 縦35px、横140pxで作成するとキレイにはまります。"),
                              _hoisted_13,
                              _hoisted_14,
                              (_ctx.rm.userInfo.user_group_role == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "変更できるのは、管理者ユーザーのみです。変更したい場合は、管理者に依頼してください。"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("section", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("table", _hoisted_20, [
                                    _createElementVNode("tbody", null, [
                                      _hoisted_21,
                                      _createElementVNode("tr", _hoisted_22, [
                                        _createElementVNode("td", _hoisted_23, [
                                          _createElementVNode("div", {
                                            class: "fl pointer withEditable changeImage posRe",
                                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeLogo && _ctx.changeLogo(...args)))
                                          }, [
                                            (_ctx.logoUrl)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                  _createElementVNode("img", {
                                                    "data-imagetype": "External",
                                                    src: _ctx.logoUrl,
                                                    style: {"max-width":"140px"},
                                                    height: "35"
                                                  }, null, 8, _hoisted_25)
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                  _hoisted_27,
                                                  _hoisted_28,
                                                  _createElementVNode("img", {
                                                    "data-imagetype": "External",
                                                    src: 
                                                                            _ctx.$getAssetImageUrl(
                                                                                `/assets/logo/waaqLink_logo_flat.gif`
                                                                            )
                                                                        ,
                                                    width: "140",
                                                    height: "17"
                                                  }, null, 8, _hoisted_29)
                                                ]))
                                          ]),
                                          _hoisted_30
                                        ])
                                      ]),
                                      _hoisted_31
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_32
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_33,
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_MdTextfieldTag, {
                              name: "",
                              style: {"height":"56px","max-width":"190px"},
                              class: "fl fs14",
                              placeholder: "【waaq株式会社】",
                              value: _ctx.us && _ctx.us.prefix_subject ? _ctx.us.prefix_subject : ``,
                              onInputValue: _ctx.inputPrefixSubject
                            }, null, 8, ["value", "onInputValue"]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("button", {
                                type: "submit",
                                class: "pointer centered circle_button skyblueBg fs16 rad8 mt15 ml20",
                                style: {"width":"100px","height":"50px","padding":"14px 8px"},
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.savePrefixSubject && _ctx.savePrefixSubject(...args)))
                              }, " 保存 ")
                            ])
                          ]),
                          _hoisted_38
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_39,
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("p", _hoisted_43, [
                              _createTextVNode(" 送信するメールのスタイルを変更します。"),
                              _hoisted_44,
                              (_ctx.us.mail_display_type)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.SelectUtil.mailDisplayTypes.find(m => m.type == _ctx.us.mail_display_type).description), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_SelectTag, {
                              name: "mail_style",
                              id: "mail_style",
                              class: "fl fs14 roundForm",
                              style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                              options: _ctx.SelectUtil.mailDisplayTypes.map(m => m.name),
                              defaultOption: _ctx.defaultMailDisplayType(),
                              onSelectValue: _ctx.selectDisplayType
                            }, null, 8, ["options", "defaultOption", "onSelectValue"])
                          ]),
                          _hoisted_47
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_48,
                    (_ctx.us && _ctx.us.mail_display_type == `simple`)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_TextareaTag, {
                              placeholder: "---------\nwaaq株式会社 \n人事部\n●●\nhttps://waaq.jp\n---------",
                              class: "fl fs13 roundForm",
                              style: {"height":"150px","width":"280px"},
                              value: _ctx.getSignature(),
                              onInputValue: _ctx.inputSignature
                            }, null, 8, ["value", "onInputValue"]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("button", {
                                type: "submit",
                                class: "pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20",
                                style: {"width":"100px","height":"50px","padding":"14px 8px"},
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args)))
                              }, " 保存 ")
                            ])
                          ]),
                          _hoisted_53
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_SelectTag, {
                              name: "mail_style",
                              id: "mail_style",
                              class: "fl fs14 roundForm",
                              style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                              options: _ctx.SelectUtil.commonDisplayTypes.map(m => m.name),
                              defaultOption: _ctx.defaultChatContentDisplayType,
                              onSelectValue: _ctx.selectChatNotificationDisplayType
                            }, null, 8, ["options", "defaultOption", "onSelectValue"])
                          ]),
                          _hoisted_57
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_58
                  ]))
                : (_ctx.selectedCategory == `addressbook`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createVNode(_component_UserSettingsAddressBook)
                    ]))
                  : (_ctx.selectedCategory == `templates`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_TemplatesContent, {
                            pageTitle: `テンプレ一覧`,
                            showEditButton: true,
                            pageFrom: `settings`,
                            members: [_ctx.demoMem]
                          }, null, 8, ["members"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
              _hoisted_62
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_63
    ]),
    _createVNode(_component_ImageBoardModal, {
      title: `ロゴを選択`,
      currentImageUrl: _ctx.logoUrl,
      onSelect: _ctx.selectFile
    }, null, 8, ["currentImageUrl", "onSelect"])
  ]))
}